<template>
	<div class="add-step-button-wrap">
		<md-button class="md-accent md-raised mobile-hide" @click="addStep">
			<base-icon icon-name="add" />
			Add step
		</md-button>
		<base-icon class="add_icon" icon-name="arrow-down" />
	</div>
</template>

<script>
export default {
	name: 'AddStepBtn',
	props: {
		arrow: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		addStep() {
			this.$emit('addStep');
		},
	},
};
</script>

<style lang="scss" scoped>
.add-step-button-wrap {
	padding: 16px 24px;
	@media (min-width: $mobile + 1) {
		@include flexColumn;
		align-items: center;
		padding: 16px 2rem;
		&:before {
			content: '';
			display: block;
			width: 2px;
			height: 8px;
			background-color: $color-blue;
		}
		button.md-button.md-theme-default:not(.md-icon-button) {
			margin: 4px 0;
		}
	}

	button {
		min-height: 32px;
		width: 107px;
		padding: 0;
		font-size: 16px;
		text-transform: none;
		letter-spacing: 0.4px;
		line-height: 23px;
		font-weight: 500;
		border-radius: 4px;
	}
}
.add_icon {
	color: $color-blue;
	transform: translateY(-0.2em);
}
</style>
